module.exports = __webpack_public_path__ + "img/slide-22.500bdc84.jpeg";